export enum LoanType {
    CONVENTIONAL = "Conventional",
    FHA = "FHA",//secured by federal housing association
    JUMBO = "Jumbo",
    HOUSING = "USDA/Rural Housing",//zero down payment
    VA = "VA",//secured by Veteran affairs loan
    INTEREST_ONLY = "Interest only", //buyer pays only the interst on the house
    OTHER = "Other",
    UNKNOWN = "Unknown"
}

